import React from 'react';
import './App.css';
import Root from './Root';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Root />
    </Router>
  );
}

export default App;
